import { createInstance } from "i18next"
import { initReactI18next } from "react-i18next"
import { DEFAULT_LANGUAGE, type SupportedLanguage } from "@/lib/language"

// Import your existing translation files
import arApplicantDashboard from "../public/locales/ar/applicant-dashboard.json"
import arApplicantDetails from "../public/locales/ar/applicant-details.json"
import arApplicantForgotPassword from "../public/locales/ar/applicant-forgot-password.json"
import arApplicantLogin from "../public/locales/ar/applicant-login.json"
import arApplicantProfile from "../public/locales/ar/applicant-profile.json"
import arApplicantSignup from "../public/locales/ar/applicant-signup.json"
import arApplicantSetupPassword from "../public/locales/ar/applicant-setup-password.json"
import arApply from "../public/locales/ar/apply.json"
import arAuthLogin from "../public/locales/ar/auth-login.json"
import arAuthResetPassword from "../public/locales/ar/auth-reset-password.json"
import arAuthSignup from "../public/locales/ar/auth-signup.json"
import arCompare from "../public/locales/ar/compare.json"
import arEvaluateCV from "../public/locales/ar/evaluate-cv.json"
import arJobDetails from "../public/locales/ar/job-details.json"
import arJobList from "../public/locales/ar/job-list.json"
import arJobs from "../public/locales/ar/jobs.json"
import arPostJob from "../public/locales/ar/post-job.json"
import arProfileGeneral from "../public/locales/ar/profile-general.json"
import arProfileSettings from "../public/locales/ar/profile-settings.json"
import arCompareApplicants from "../public/locales/ar/compare-applicants.json"
import arJobEdit from "../public/locales/ar/job-edit.json"
import arApplicantProfileEdit from "../public/locales/ar/applicant-profile-edit.json"
import arCompanyProfileEdit from "../public/locales/ar/company-profile-edit.json"
import arHome from "../public/locales/ar/home.json" // Import Arabic home translations
import arLegal from "../public/locales/ar/legal.json" // Import Arabic legal translations
import arApplicantSettings from "../public/locales/ar/applicant-settings.json"
import arPricing from "../public/locales/ar/pricing.json"

import enApply from "../public/locales/en/apply.json"
import enPostJob from "../public/locales/en/post-job.json"
import enApplicantForgotPassword from "../public/locales/en/applicant-forgot-password.json"
import enApplicantLogin from "../public/locales/en/applicant-login.json"
import enApplicantSignup from "../public/locales/en/applicant-signup.json"
import enApplicantSetupPassword from "../public/locales/en/applicant-setup-password.json"


// Import English translation files
import enHome from "../public/locales/en/home.json"
import enJobs from "../public/locales/en/jobs.json"
import enJobList from "../public/locales/en/job-list.json"
import enJobDetails from "../public/locales/en/job-details.json"
import enApplicantDetails from "../public/locales/en/applicant-details.json"
import enAuthLogin from "../public/locales/en/auth-login.json"
import enAuthSignup from "../public/locales/en/auth-signup.json"
import enApplicantDashboard from "../public/locales/en/applicant-dashboard.json"
import enCompareApplicants from "../public/locales/en/compare-applicants.json"
import enProfileGeneral from "../public/locales/en/profile-general.json"
import enEvaluateCV from "../public/locales/en/evaluate-cv.json"
import enJobEdit from "../public/locales/en/job-edit.json"
import enApplicantProfileEdit from "../public/locales/en/applicant-profile-edit.json"
import enCompanyProfileEdit from "../public/locales/en/company-profile-edit.json"
import enProfileSettings from "../public/locales/en/profile-settings.json"
import enLegal from "../public/locales/en/legal.json" // Import English legal translations
import enApplicantSettings from "../public/locales/en/applicant-settings.json"
import enPricing from "../public/locales/en/pricing.json"
 
 
export const resources = {
  en: {
    translation: {
      // Navigation translations (working)
      navigation: {
        home: "Home",
        browseJobs: "Browse Jobs",
        evaluateCV: "Evaluate CV",
        dashboard: "Dashboard",
        postJob: "Post a Job",
        jobList: "Job List",
        enJobDetails: "job-details",
        enApplicantDetails: "applicant-details",
        myProfile: "My Profile",
        settings: "Settings",
        signOut: "Sign Out",
        jobSeeker: "Applicant",
        employer: "Employer",
        jobSeekerLogin: "Applicant Login",
        employerLogin: "Employer Login",
        aiHrPortal: "AI HR Portal",
        company: "Employer",
        generalNavigation: "General Navigation",
        companyTools: "Company Tools",
        jobSeekerSection: "Applicant Section",
        accountSection: "Account Section"
      },
      common: {
        loading: "Loading...",
        error: "Error",
        success: "Success",
        cancel: "Cancel",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        search: "Search",
        filter: "Filter",
        apply: "Apply",
        submit: "Submit",
        home: "Home"
      }
    },
    // Keep ALL your existing namespaces
    home: enHome,
    jobs: enJobs,
    apply: enApply,
    "job-list": enJobList,
    "auth-login": enAuthLogin,
    "auth-signup": enAuthSignup,
    "job-details": enJobDetails,
    "applicant-details": enApplicantDetails,
    "applicant-dashboard": enApplicantDashboard,
    "profile-general": enProfileGeneral,
    "applicant-login": enApplicantLogin,
    "applicant-signup": enApplicantSignup,
    "applicant-setup-password": enApplicantSetupPassword,
    "evaluate-cv": enEvaluateCV,
    "compare-applicants": enCompareApplicants,
    "job-edit": enJobEdit,
    "applicant-profile-edit": enApplicantProfileEdit,
    "company-profile-edit": enCompanyProfileEdit,
    "profile-settings": enProfileSettings,
    "applicant-settings": enApplicantSettings,
    "applicant-forgot-password": enApplicantForgotPassword,
    "post-job": enPostJob,
    pricing: enPricing, // Add English pricing translations
    legal: enLegal // Add English legal translations
  },
  ar: {
    translation: {
      // Navigation translations (working)
      navigation: {
        home: "الرئيسية",
        browseJobs: "تصفح الوظائف",
        evaluateCV: "قيّم سيرة ذاتية",
        dashboard: "لوحة التحكم",
        postJob: "نشر وظيفة",
        jobList: "قائمة الوظائف",
        myProfile: "ملفي الشخصي",
        settings: "الإعدادات",
        signOut: "تسجيل الخروج",
        jobSeeker: "متقدم",
        employer: "صاحب عمل",
        jobSeekerLogin: "تسجيل دخول المتقدم",
        employerLogin: "تسجيل دخول صاحب عمل",
        aiHrPortal: "بوابة الذكاء الاصطناعي للموارد البشرية",
        company: "صاحب العمل",
        generalNavigation: "التنقل العام",
        companyTools: "أدوات الشركة",
        jobSeekerSection: "قسم المتقدم",
        accountSection: "قسم الحساب"
      },
      common: {
        loading: "جاري التحميل...",
        error: "خطأ",
        success: "نجح",
        cancel: "إلغاء",
        save: "حفظ",
        edit: "تعديل",
        delete: "حذف",
        search: "بحث",
        filter: "تصفية",
        apply: "تطبيق",
        submit: "إرسال",
        home: "الرئيسية"
      }
    },
    // Keep ALL your existing Arabic translations
    home: arHome,
    jobs: arJobs,
    apply: arApply,
    "post-job": arPostJob,
    "job-list": arJobList,
    "profile-general": arProfileGeneral,
    "applicant-dashboard": arApplicantDashboard,
    "applicant-details": arApplicantDetails,
    "applicant-forgot-password": arApplicantForgotPassword,
    "applicant-login": arApplicantLogin,
    "applicant-profile": arApplicantProfile,
    "applicant-signup": arApplicantSignup,
    "applicant-setup-password": arApplicantSetupPassword,
    "auth-login": arAuthLogin,
    "auth-reset-password": arAuthResetPassword,
    "auth-signup": arAuthSignup,
    "compare": arCompare,
    "evaluate-cv": arEvaluateCV,
    "job-details": arJobDetails,
    "profile-settings": arProfileSettings,
    "compare-applicants": arCompareApplicants,
    "job-edit": arJobEdit,
    "applicant-profile-edit": arApplicantProfileEdit,
    "company-profile-edit": arCompanyProfileEdit,
    "applicant-settings": arApplicantSettings,
    pricing: arPricing, // Add Arabic pricing translations
    legal: arLegal // Add Arabic legal translations
  },
}

const namespaces = [
  "translation",
  "home",
  "jobs",
  "apply",
  "post-job",
  "job-list",
  "job-details",
  "profile-general",
  "applicant-dashboard",
  "applicant-details",
  "applicant-forgot-password",
  "applicant-login",
  "applicant-signup",
  "applicant-profile",
  "applicant-setup-password",
  "applicant-settings",
  "auth-login",
  "auth-reset-password",
  "auth-signup",
  "compare",
  "compare-applicants",
  "evaluate-cv",
  "profile-settings",
  "job-edit",
  "applicant-profile-edit",
  "company-profile-edit",
  "pricing",
  "legal",
] as const

export function createI18nInstance(initialLanguage: SupportedLanguage = DEFAULT_LANGUAGE) {
  const instance = createInstance()

  instance.use(initReactI18next).init({
    resources,
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    ns: namespaces,
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    initImmediate: false,
  })

  return instance
}

const i18n = createI18nInstance()

export default i18n
